import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button } from 'antd';

import MediaPermissionInstruction from '../InviteUI/MediaPermissionInstruction';
import MediaPermissionComponent from './MediaPermission/MediaPermissionComponent';
// import { MeetingProvider } from 'amazon-chime-sdk-component-library-react';

import styles from '../InviteUI/InviteContainer.scss';

const MediaSetupGuide = () => {
  const { assessment_id } = useParams();
  const [showPermissionComponent, setShowPermissionComponent] = useState(false);

  const onClick = () => setShowPermissionComponent(true);

  return (
    <div className={styles['media-setup-guide']}>
      {!showPermissionComponent ? (
        <>
          <MediaPermissionInstruction onClick={onClick} />
        </>
      ) : (
        // <MeetingProvider>
        <MediaPermissionComponent assessment_id={assessment_id} />
        // </MeetingProvider>
      )}
    </div>
  );
};

export default MediaSetupGuide;
